import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Divider,
  Typography
} from '@mui/material';
import UploadRow from './UploadRow';
import RestorableUploadRow from './RestorableUploadRow';

const BankDetailsDialog = ({
  open,
  onClose,
  bankDetails,
  onBankInputChange,
  hasNoCheque,
  mandateFile,
  mandateFileLink,
  onMandateUpload,
  onPreview
}) => {
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/i;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Enter Bank Details</DialogTitle>
      <DialogContent>
        <TextField
          label="Bank Name"
          fullWidth
          margin="normal"
          value={bankDetails.bankName}
          onChange={onBankInputChange('bankName')}
        />
        <TextField
          label="IFSC Code"
          fullWidth
          margin="normal"
          value={bankDetails.ifsc}
          onChange={onBankInputChange('ifsc')}
          error={bankDetails.ifsc && !ifscRegex.test(bankDetails.ifsc)}
          helperText={
            bankDetails.ifsc && !ifscRegex.test(bankDetails.ifsc)
              ? 'Enter a valid IFSC code (e.g., HDFC0001234)'
              : ''
          }
        />
        <TextField
          label="Account Number"
          fullWidth
          margin="normal"
          value={bankDetails.accountNumber}
          onChange={onBankInputChange('accountNumber')}
        />
        <TextField
          label="Cheque Number"
          fullWidth
          margin="normal"
          value={bankDetails.chequeNumber}
          onChange={onBankInputChange('chequeNumber')}
        />
        <Divider sx={{ my: 2 }} />
        {hasNoCheque && (
          <>
            {mandateFileLink && !mandateFile ? (
              <RestorableUploadRow
                label="Bank Mandate From"
                file={mandateFile}
                fileLink={mandateFileLink}
                handler={onMandateUpload}
                onPreview={onPreview}
                fileName={(() => {
                  if (!mandateFileLink) return null;
                  const urlParts = mandateFileLink.split('/');
                  const fileName = urlParts[urlParts.length - 1];
                  return fileName.includes('.') ? fileName : 'bank-mandate.pdf';
                })()}
              />
            ) : (
              <UploadRow
                label="Bank Mandate From"
                file={mandateFile}
                handler={onMandateUpload}
                onPreview={onPreview}
              />
            )}
            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
              Please upload Bank Mandate form.
            </Typography>
          </>
        )}
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
        >
          Save Details
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default BankDetailsDialog;